import { useEffect, useMemo, useState } from 'react';
import { api } from '../api.ts';

/* DIE VORSCHLAGSLISTE DER EMPFÄNGER (.259).
 * ============================================================================
 * ORIGINALTEXT MARVIN (30.09.2026)
 *   „soll er sich die empfänger merken bzw wie eine vorschlagsliste haben,
 *    damit dort kein fehler passiert beim einlesen der bankdaten"
 *
 * Ein Namensfeld, unter dem beim Tippen die gemerkten Empfänger stehen,
 * bestätigte zuerst. Ein Tipp auf einen füllt Name, IBAN und BIC zusammen:
 * die IBAN wird dann nicht abgetippt, sondern übernommen. */

export type Empfaenger = { id: string; name: string; iban: string; iban_lesbar: string; bic: string | null;
  bestaetigt_am: string | null; gemeinde: string | null; firma: string | null; anzahl_zahlungen: number };

export function Empfaengerwahl({ wert, setze, waehle, art, titel = 'Empfänger (Kontoinhaber)', breite = 320 }: {
  wert: string; setze: (w: string) => void; waehle: (e: Empfaenger) => void;
  art?: 'behoerde' | 'partner'; titel?: string; breite?: number;
}) {
  const [liste, setListe] = useState<Empfaenger[]>([]);
  const [offen, setOffen] = useState(false);
  useEffect(() => { api.zahlungsempfaenger(art).then((d) => setListe(d.empfaenger)).catch(() => {}); }, [art]);
  const treffer = useMemo(() => {
    const s = wert.trim().toLowerCase().replace(/\s/g, '');
    return liste.filter((e) => !s || e.name.toLowerCase().replace(/\s/g, '').includes(s) || e.iban.toLowerCase().includes(s)
      || String(e.gemeinde ?? e.firma ?? '').toLowerCase().includes(s)).slice(0, 8);
  }, [wert, liste]);
  return (
    <div className="feld empfaengerwahl" style={{ width: breite }}>
      <label htmlFor="empfaenger">{titel}</label>
      <input id="empfaenger" value={wert} autoComplete="off" maxLength={140}
             onChange={(e) => { setze(e.target.value); setOffen(true); }}
             onClick={() => setOffen(true)} onBlur={() => setTimeout(() => setOffen(false), 150)} />
      {offen && treffer.length > 0 && (
        <ul className="empfaengerliste" role="listbox">
          {treffer.map((e) => (
            <li key={e.id} role="option" aria-selected={false}
                onMouseDown={(ev) => { ev.preventDefault(); waehle(e); setOffen(false); }}>
              <b>{e.name}</b> {e.bestaetigt_am ? <span className="merker gruen klein">bestätigt</span> : <span className="merker klein">Vorschlag</span>}
              <div className="klein leise">{e.iban_lesbar}{e.gemeinde ? `, ${e.gemeinde}` : e.firma ? `, ${e.firma}` : ''}{e.anzahl_zahlungen ? `, ${e.anzahl_zahlungen}× bezahlt` : ''}</div>
            </li>
          ))}
        </ul>
      )}
      <div className="feldhinweis">Tippen zeigt gemerkte Empfänger; ein Klick übernimmt Name, IBAN und BIC.</div>
    </div>
  );
}
